/**
 * Performance PDP sticky ATC — wellnesse-pdp-white.html (top bar, tier + flavor sync).
 */
(function () {
  var STICKY_ID = "sticky-atc";
  var MAIN_ATC_SEL =
    "#product-template .product-buy-buttons .btn-atc.performance-pdp-reference-atc, #product-template .product-buy-buttons .btn-atc[type='submit']";

  function getRoot() {
    return document.getElementById("product-template");
  }

  function getSticky() {
    return document.getElementById(STICKY_ID);
  }

  function getMainAtc() {
    var root = getRoot();
    if (!root) return null;
    return root.querySelector(MAIN_ATC_SEL);
  }

  var headerOffsetCache = null;

  function measureHeaderOffset() {
    var h = 0;
    var announcement = document.querySelector(".announcement-bar-sticky");
    if (
      announcement &&
      getComputedStyle(announcement.closest(".shopify-section") || announcement).position !== "static"
    ) {
      h += announcement.offsetHeight || 0;
    }
    var navbar = document.querySelector('[id*="__navbar"].sticky-top, .header.sticky-top, header.sticky-top');
    if (navbar) h += navbar.offsetHeight || 0;
    return h;
  }

  function refreshHeaderOffsetCache() {
    var wasActive = document.documentElement.classList.contains("performance-pdp-sticky-atc-active");
    if (wasActive) {
      document.documentElement.classList.remove("performance-pdp-sticky-atc-active");
    }
    headerOffsetCache = measureHeaderOffset();
    if (wasActive) {
      document.documentElement.classList.add("performance-pdp-sticky-atc-active");
    }
  }

  function getHeaderOffset() {
    if (headerOffsetCache === null) {
      headerOffsetCache = measureHeaderOffset();
    }
    return headerOffsetCache;
  }

  function getFlavorLabel() {
    var root = getRoot();
    if (root) {
      var checked = root.querySelector(".metafield-variations-pill-input:checked");
      if (checked) {
        var pillLabel = root.querySelector(
          'label[for="' + checked.id + '"] .metafield-variations-item__label'
        );
        if (pillLabel && pillLabel.textContent.trim()) {
          return pillLabel.textContent.trim();
        }
      }
    }
    var active = document.querySelector(
      ".metafield-variations-item.metafield-variations-active .metafield-variations-item__label"
    );
    if (active && active.textContent.trim()) return active.textContent.trim();
    return "";
  }

  function getActiveTier() {
    var root = getRoot();
    if (!root) return null;
    return root.querySelector(
      ".performance-pdp-tier--active[data-performance-pdp-tier]"
    );
  }

  function syncStickyContent() {
    var sticky = getSticky();
    if (!sticky || !sticky.classList.contains("sticky-atc--performance")) return;

    var tier = getActiveTier();
    var nowEl = sticky.querySelector("[data-sticky-atc-now]");
    var wasEl = sticky.querySelector("[data-sticky-atc-was]");
    var variantEl = sticky.querySelector("[data-sticky-atc-variant]");

    if (tier) {
      var tierNow = tier.querySelector("[data-tier-price-now]");
      var tierWas = tier.querySelector("[data-tier-price-was]");
      if (nowEl && tierNow) nowEl.textContent = tierNow.textContent.trim();

      if (wasEl) {
        if (tierWas && tierWas.textContent.trim() && tierWas.style.display !== "none") {
          wasEl.textContent = tierWas.textContent.trim();
          wasEl.removeAttribute("hidden");
        } else {
          wasEl.textContent = "";
          wasEl.setAttribute("hidden", "");
        }
      }
    }

    if (variantEl) {
      var flavor = getFlavorLabel();
      var tierLabel = tier ? (tier.dataset.tierLabel || "").trim() : "";
      if (flavor && tierLabel) {
        variantEl.textContent = flavor + " · " + tierLabel;
      } else if (tierLabel) {
        variantEl.textContent = tierLabel;
      } else if (flavor) {
        variantEl.textContent = flavor;
      } else {
        variantEl.textContent = "";
      }
    }
  }

  function isDesktopSticky() {
    return window.matchMedia("(min-width: 980px)").matches;
  }

  function setHeaderHidden(hidden) {
    document.documentElement.classList.toggle(
      "performance-pdp-sticky-atc-active",
      hidden && isDesktopSticky()
    );
  }

  function updateVisibility() {
    var sticky = getSticky();
    var mainAtc = getMainAtc();
    if (!sticky || !mainAtc) return;

    var threshold = getHeaderOffset();
    var rect = mainAtc.getBoundingClientRect();
    var show = rect.bottom < threshold;

    if (show) {
      sticky.classList.add("show");
      sticky.setAttribute("aria-hidden", "false");
      setHeaderHidden(true);
      syncStickyContent();
    } else {
      sticky.classList.remove("show");
      sticky.setAttribute("aria-hidden", "true");
      setHeaderHidden(false);
    }
  }

  function bindSubmit() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-sticky-atc-submit]");
      if (!btn || btn.disabled) return;
      var mainAtc = getMainAtc();
      if (!mainAtc || mainAtc.disabled) return;
      e.preventDefault();

      var form = mainAtc.closest && mainAtc.closest('form[action*="/cart/add"]');
      if (form && form.classList.contains("loading")) return;

      /* Avoid jumping to the top form button; submit through same AJAX handler directly. */
      if (form && typeof window.onSubmitAtcForm === "function") {
        window.onSubmitAtcForm(form, {
          preventDefault: function () {},
          stopPropagation: function () {},
        });
        return;
      }

      mainAtc.click();
    });
  }

  function bindScroll() {
    var ticking = false;
    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            updateVisibility();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );
    window.addEventListener(
      "resize",
      function () {
        refreshHeaderOffsetCache();
        updateVisibility();
      },
      { passive: true }
    );
  }

  function boot() {
    var sticky = getSticky();
    if (!sticky || !sticky.classList.contains("sticky-atc--performance")) return;

    bindSubmit();
    bindScroll();
    refreshHeaderOffsetCache();
    updateVisibility();
    syncStickyContent();
  }

  document.addEventListener("performance-pdp:tier-changed", syncStickyContent);
  document.addEventListener("click", function (e) {
    if (e.target.closest(".metafield-variations-item")) {
      window.setTimeout(syncStickyContent, 80);
    }
  });
  document.addEventListener("sticky-atc:replaced", function () {
    headerOffsetCache = null;
    window.setTimeout(boot, 50);
  });
  document.addEventListener("performance-pdp:flavor-variant-changed", function () {
    syncStickyContent();
  });

  document.addEventListener("product:flavor-section-swapped", function () {
    headerOffsetCache = null;
    window.setTimeout(function () {
      boot();
      updateVisibility();
    }, 150);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.syncPerformanceStickyAtc = syncStickyContent;
})();
